<app-block-wrapper [_editable]="_editable" [style]="style">
  <div class="storyblok-claim" [class.has-image]="!!image.filename">
    <img [src]="image.filename | storyblokCdn" [alt]="image.alt" *ngIf="image?.filename" />
    <div class="claim-text">
      {{ text }}
    </div>
  </div>
</app-block-wrapper>
